module.exports = __webpack_public_path__ + "img/Madeline-Haines.5d2bb9e6.jpg";